import dayjs from "dayjs";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var JobCardDetailsMobile = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        margin: '12px',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'BranchName',
                        label: 'Branch :',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            textOverflow: 'unset',
                            minWidth: '40%'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12,
                        sx: {
                            textAlign: 'right'
                        },
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.BranchName) {
                                var BranchName = formData !== null && formData !== void 0 && formData.BranchName ? formData === null || formData === void 0 ? void 0 : formData.BranchName : '-';
                                return BranchName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Job card no:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'JobCard',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.JobCard) {
                                var JobCard = formData !== null && formData !== void 0 && formData.JobCard ? formData === null || formData === void 0 ? void 0 : formData.JobCard : '-';
                                return JobCard;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Job card date:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'DocDate',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.DocDate) {
                                var DocDate = formData !== null && formData !== void 0 && formData.DocDate ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.DocDate).format('DD MMM, YYYY') : '-';
                                return DocDate;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'jc-customer-model',
                        children: 'Product:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Model',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.Model) {
                                var model = formData !== null && formData !== void 0 && formData.Model ? formData === null || formData === void 0 ? void 0 : formData.Model : '-';
                                return model;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'CustomerName',
                        label: 'Customer name:',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            textOverflow: 'unset',
                            minWidth: '40%'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12,
                        sx: {
                            textAlign: 'right'
                        },
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.CustomerName) {
                                var CustomerName = formData !== null && formData !== void 0 && formData.CustomerName ? formData === null || formData === void 0 ? void 0 : formData.CustomerName : '-';
                                return CustomerName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Customer no:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Mobile',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.Mobile) {
                                var Mobile = formData !== null && formData !== void 0 && formData.Mobile ? formData === null || formData === void 0 ? void 0 : formData.Mobile : '-';
                                return Mobile;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'ServiceAdvisorName',
                        label: 'Service advisor:',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            textOverflow: 'unset',
                            minWidth: '40%'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12,
                        sx: {
                            textAlign: 'right'
                        },
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.ServiceAdvisorName) {
                                var ServiceAdvisorName = formData !== null && formData !== void 0 && formData.ServiceAdvisorName ? formData === null || formData === void 0 ? void 0 : formData.ServiceAdvisorName : '-';
                                return ServiceAdvisorName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'MechanicName',
                        label: 'Technician:',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            textOverflow: 'unset',
                            minWidth: '40%'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12,
                        sx: {
                            textAlign: 'right'
                        },
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.MechanicName) {
                                var MechanicName = formData !== null && formData !== void 0 && formData.MechanicName ? formData === null || formData === void 0 ? void 0 : formData.MechanicName : '-';
                                return MechanicName;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Service type:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'JobType',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.JobType) {
                                var JobType = formData !== null && formData !== void 0 && formData.JobType ? formData === null || formData === void 0 ? void 0 : formData.JobType : '-';
                                return JobType;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'CustomerVoice',
                        label: 'Customer voice:',
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            textOverflow: 'unset',
                            minWidth: '40%'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12,
                        sx: {
                            textAlign: 'right'
                        },
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.CustomerVoice) {
                                var CustomerVoice = formData !== null && formData !== void 0 && formData.CustomerVoice ? formData === null || formData === void 0 ? void 0 : formData.CustomerVoice : '-';
                                return CustomerVoice;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Odomer reading:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'UsageReading',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.UsageReading) {
                                var UsageReading = formData !== null && formData !== void 0 && formData.UsageReading ? formData === null || formData === void 0 ? void 0 : formData.UsageReading : '-';
                                return UsageReading;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Invoice number(s):',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'secondary.500',
                        flexWrap: 'nowrap'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Invoices',
                        fontWeight: 'medium',
                        columnSize: 0,
                        fontSize: 'sm',
                        sx: {
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                            maxWidth: '100%',
                            overflow: 'hidden'
                        },
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.Invoices) {
                                var Invoices = formData !== null && formData !== void 0 && formData.Invoices ? formData === null || formData === void 0 ? void 0 : formData.Invoices : '-';
                                return Invoices;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }]
    }];
